import React from 'react';
import { Link } from 'react-router-dom';
import { OFFICE_ADDRESS, OFFICE_MAPS_URL } from '../../config/office';
import './FinalCTASection.css';

const FinalCTASection = ({ darkMode }) => {
  const contactInfo = [
    { icon: '📞', label: 'Teléfono', value: '+34 822 68 50 12' },
    { icon: '📧', label: 'Email', value: 'comercial@e-asy.es' },
    { icon: '📍', label: 'Oficina', value: OFFICE_ADDRESS, href: OFFICE_MAPS_URL },
    { icon: '🕐', label: 'Horario', value: '9:00 - 17:00' },
  ];

  const trustItems = [
    {
      icon: '🧭',
      title: 'Criterio antes que licencias',
      description:
        'Te decimos si el problema es el software, el proceso o la integración. Sin inflar proyectos.',
    },
    {
      icon: '🤝',
      title: 'Misma gente en diagnóstico y en implantación',
      description:
        'No vendemos humo en reunión para luego desaparecer: acompañamos el cambio con contacto directo.',
    },
    {
      icon: '🔧',
      title: 'Producto propio y proyectos a medida',
      description:
        'Mantenemos Vulpin 360 y, al mismo tiempo, integramos y automatizamos sobre lo que ya usas.',
    },
    {
      icon: '📋',
      title: 'Fases que puedes usar en producción',
      description:
        'Entregas pequeñas y revisables, para que el equipo gane confianza antes de abrir el siguiente frente.',
    },
  ];

  const finalStats = [
    {
      number: '60+',
      label: 'Proyectos acompañados',
      description: 'Pymes, ONG y equipos que necesitaban orden en la gestión',
    },
    {
      number: 'Tenerife',
      label: 'Base en Canarias',
      description: 'Trabajo presencial y remoto con equipos en toda España',
    },
    {
      number: 'ERP + auto + integración',
      label: 'Lo que más repetimos',
      description: 'Las tres patas donde suele estar el dolor real',
    },
    {
      number: '4 h',
      label: 'Objetivo de respuesta',
      description: 'Soporte y consultas comerciales en horario laboral',
    },
  ];

  return (
    <section className={`final-cta-section ${darkMode ? 'dark' : 'light'}`}>
      <div className="final-cta-content">
        <div className="final-cta-header">
          <h2 className="final-cta-title">Hablemos de tu gestión, no de “transformación digital”</h2>
          <p className="final-cta-subtitle">
            Preferimos una llamada concreta a un formulario eterno. Si mandas
            contexto (herramientas que usas, tamaño del equipo, qué duele),
            llegamos más preparados.
          </p>
        </div>

        <div className="final-cta-main">
          <div className="cta-actions">
            <div className="secondary-cta">
              <div className="cta-header-section">
                <h3 className="cta-action-title">Contacto directo</h3>
                <p className="cta-action-description">
                  Para solicitar una demo adaptada de Vulpin o revisar integraciones
                  y ERP sin compromiso rígido.
                </p>
              </div>
              <Link to="/contacto" className="cta-secondary-button">
                Solicitar una demo adaptada
              </Link>
              <div className="contact-info">
                {contactInfo.map((contact, index) => (
                  <div key={index} className="contact-item">
                    <div className="contact-icon">{contact.icon}</div>
                    <div className="contact-details">
                      <span className="contact-label">{contact.label}</span>
                      {contact.href ? (
                        <a className="contact-value" href={contact.href} target="_blank" rel="noopener noreferrer">
                          {contact.value}
                        </a>
                      ) : (
                        <span className="contact-value">{contact.value}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="trust-elements">
            <div className="trust-header">
              <h3 className="trust-title">Cómo trabajamos</h3>
              <p className="trust-subtitle">
                Sin promesas mágicas: proceso claro y entregas que puedes tocar
              </p>
            </div>

            <div className="trust-grid">
              {trustItems.map((item, index) => (
                <div key={index} className="trust-item">
                  <div className="trust-item-icon">{item.icon}</div>
                  <h4 className="trust-item-title">{item.title}</h4>
                  <p className="trust-item-description">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="final-stats">
          {finalStats.map((stat, index) => (
            <div key={index} className="final-stat-item">
              <div className="final-stat-number">{stat.number}</div>
              <div className="final-stat-label">{stat.label}</div>
              <div className="final-stat-description">{stat.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
